import "./sass/layout.scss";

import '../modules/component/common/module.js';
import '../modules/component/image/module.js';

import '../modules/eiovisual/cover/module.js';
import '../modules/eiovisual/pattern1/module.js';
import '../modules/eiovisual/pattern2/module.js';
import '../modules/eiovisual/pattern3/module.js';
import '../modules/eiovisual/pattern4/module.js';
import '../modules/eiovisual/pattern5/module.js';
import '../modules/eiovisual/pattern6/module.js';
import '../modules/eiovisual/parallax1/module.js';
import '../modules/eiovisual/solo1/module.js';
import '../modules/eiovisual/advanced-image/module.js';
import '../modules/eiovisual/solo1-variabile/module.js';
import '../modules/eiovisual/solo2/module.js';
import '../modules/eiovisual/cf7/module.js';
import '../modules/eiovisual/header1/module.js';
import '../modules/eiovisual/header2/module.js';
import '../modules/eiovisual/text1/module.js';
import '../modules/eiovisual/text1-noscroll/module.js';
import '../modules/eiovisual/text2/module.js';
import '../modules/eiovisual/text3/module.js';
import '../modules/eiovisual/adabe/module.js';
import '../modules/eiovisual/pcon/module.js';
import '../modules/eiovisual/configuratore/module.js';
import '../modules/eiovisual/coverprodotto/module.js';
import '../modules/eiovisual/coverdesigner/module.js';
import '../modules/eiovisual/list1/module.js';
import '../modules/eiovisual/space/module.js';
import '../modules/eiovisual/product-of-designer/module.js';
import '../modules/eiovisual/gallery1/module.js';
import '../modules/eiovisual/menu1/module.js';
import '../modules/eiovisual/menu2/module.js';
import '../modules/eiovisual/button1/module.js';
import '../modules/eiovisual/button2/module.js';
import '../modules/eiovisual/button3/module.js';
import '../modules/eiovisual/anchor/module.js';
import '../modules/eiovisual/configuratore/module.js';
import '../modules/eiovisual/accordion-row-start/module.js';

// import '@webcomponents/webcomponentsjs/webcomponents-loader.js'
import '@babel/polyfill/noConflict';

// require('offline-plugin/runtime').install();

// missing forEach on NodeList for IE11
if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
}

/**
 * Array.prototype.forEach() polyfill
 * @author Chris Ferdinandi
 * @license MIT
 */
if (!Array.prototype.forEach) {
	Array.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window;
		for (var i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this);
		}
	};
}